import { PROJECT_MEDIA_TYPES } from 'consts'

import { IMediaItem, MediaStatus } from 'types/media'

export const checkIfAIImageIsGenerating = (item: IMediaItem) => {
  const isAIImage =
    item.type === PROJECT_MEDIA_TYPES.aiImage &&
    item.meta.status === MediaStatus.PENDING &&
    item.id

  return !!isAIImage
}
